import { CirclePlus } from 'lucide-react';
import type { ReactNode } from 'react';
import type { TRuleEditorCommonProps } from '../types';
import type { TQuestionRuleCondition } from 'types/rules.types';
import { HubertButton } from 'components/HubertUI/HubertButton';

interface Props extends TRuleEditorCommonProps {
  conditions: TQuestionRuleCondition[];
  renderCondition: (condition: TQuestionRuleCondition, conditionIdx: number) => ReactNode;
  addLabel: string;
  onAdd: () => void;
}

const RuleConditions = ({ isReadOnly, conditions, renderCondition, addLabel, onAdd }: Props) => (
  <div className="mt-12 flex flex-col gap-16">
    {conditions.map((condition, conditionIdx) => renderCondition(condition, conditionIdx))}

    {!isReadOnly ? (
      <HubertButton size="sm" variant="outline" icon={<CirclePlus />} onClick={onAdd}>
        {addLabel}
      </HubertButton>
    ) : null}
  </div>
);

export default RuleConditions;
